import styled from 'styled-components';

import Theme from '../../../theme/Theme';

const DashboardStyle = styled.div`
  .dashboard-header-filter {
    max-width: 540px;
  }

  @media only screen and (min-width: 768px) {
    .dashboard-header-filter {
      margin: 0 0 0 auto;
    }
  }
`;

export const PopOverMsg = styled.div`
  min-height: 40px;
  background: #fbf2f2;
  color: ${Theme.black};
  font-size: 13px;
  padding: 12px;
  text-align: center;
  font-family: ${Theme.baseMediumFontFamily};
`;

export default DashboardStyle;
